// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".formError{width:100%}.formError__content{background:#d364771a;border-radius:var(--radiusSmaller);font-size:16px;line-height:1.24em;padding:10px 12px;width:100%}.formError__icon{float:left;height:16px;margin:4px 7px 0 0;width:16px}.formError .formError__content.formError__content>p{margin:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
